import { objectToCamelCase, objectToSnakeCase } from '../utils'
import options from './options'

export default class SurveyQuestion {
  static options = options
  constructor(question) {
    const {
      id = '',
      text = '',
      textEs = '',
      textEn = '',
      qType = '',
      description = '',
      descriptionEs = '',
      descriptionEn = '',
      introduction = '',
      introductionEs = '',
      introductionEn = '',
      information = '',
      informationEs = '',
      informationEn = '',
      order = '',
      humanReadableId = null,
      answerOptions = [],
      answer = null,
      isArchived = null,
      isOptional = null,
      style = null,
    } = question
    Object.assign(this, {
      id,
      text,
      textEs,
      textEn,
      qType,
      description,
      descriptionEs,
      descriptionEn,
      introduction,
      introductionEs,
      introductionEn,
      information,
      informationEs,
      informationEn,
      order,
      humanReadableId,
      answerOptions,
      answer: SurveyAnswer.fromAPI(answer),
      isArchived,
      isOptional,
      style,
    })
  }

  static create(opts) {
    return new SurveyQuestion(opts)
  }

  static fromAPI(json) {
    return new SurveyQuestion(objectToCamelCase(json))
  }

  get isEmpty() {
    switch (this.qType) {
      case options.MULTIPLE_CHOICE:
        return !this.answer.option
      case options.FREE_TEXT:
        return !this.answer.text
      case options.NUMBER:
        return !this.answer.text
      case options.MULTI_SELECT:
        return this.answer.options.length === 0
      case options.FULL_NAME:
        return !this.answer.text
      case options.PHONE_NUMBER:
        return !this.answer.text
      case options.EMAIL:
        return !this.answer.text
      case options.MULTIPLE_CHOICE_ADDITIONAL:
        return !this.answer.option
      case options.YES_NO_ADDITIONAL:
        return !this.answer.option
      case options.UF_VALID_ZIP_CODE:
        return !this.answer.text
      case options.CHECKBOX:
        return !this.answer.text
      default:
        throw new Error(`Error checking question is empty, question type "${this.qType}"
                         is not recognized.`)
    }
  }
  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The readOnlyFields are always excluded.
   **/
  static toAPI(surveyQuestion, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = surveyQuestion[field]
      })
    } else {
      data = surveyQuestion
    }

    //
    excludeFields = [...SurveyQuestion.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }
}

class SurveyAnswer {
  constructor(answer) {
    const { text = '', textEs = '', textEn = '', option = null, options = [] } = answer
    Object.assign(this, {
      text,
      textEs,
      textEn,
      option,
      options,
    })
  }

  static create(opts) {
    return new SurveyAnswer(opts)
  }
  static fromAPI(json) {
    // NIP 3/11/20 If no SurveyAnswer is provided, replace it with an empty one
    //             This will make parsing easier for us down the road
    if (json === null) {
      json = {}
    }
    return new SurveyAnswer(objectToCamelCase(json))
  }
}
